
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowDownIcon from '../Icons/ArrowDownIcon';
import { childTreeValidator } from '../../utils/Components';
import { AlertIcon } from '../Icons/AlertIcon';
import { ErgoElementsContext } from '../Provider';

const allowedChildTypes = ['option', 'optgroup'];

const childValidator = (child) => {
  if (!child || !child.props) {
    // Text nodes or invalid elements
    return true;
  }
  return typeof child.type === 'string' && allowedChildTypes.includes(child.type);
};

const propTypes = {
  error: PropTypes.any,
  children: childTreeValidator(childValidator, (componentName) =>
    `${componentName} can only contain (nested) children of type ${allowedChildTypes.join(', ')}`
  ),
  id: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  variant: PropTypes.string,
};

const Select = ({
  children,
  id,
  className,
  error = false,
  multiple, // currently ignored
  variant,
  ...other
}) => {
  const componentClassName = classNames(className, 'ee_select');

  return (
    <span className={componentClassName}>
      <select
        id={id}
        data-focus-id={id}
        className="ee_select__control"
        aria-invalid={Boolean(error)}
        {...other}
      >
        {children}
      </select>

      <span className="ee_select__toggle-wrapper">
        <ArrowDownIcon className="ee_select__toggle" />
      </span>

      {Boolean(error) && (
        <ErgoElementsContext.Consumer>
          {(context) =>
            context.theme === 'ergo' && (
              <span className="ee_select__error-icon-wrapper">
                <AlertIcon className="ee_select__error-icon" />
              </span>
            )
          }
        </ErgoElementsContext.Consumer>
      )}
    </span>
  );
};

Select.propTypes = propTypes;
Select.defaultProps = {
  error: false,
};

export default Select;
